import { LoginResponse } from '@api/FW/auth.api';

// TODO: This whole login flow gotta be refactored.
export interface IEloginResponseAdapter {
	SessionID: string;
	NeedSecondStep: number;
	OilWalletsUserId: string;
	Roles: {
		Expediter: number;
		StoreKeeper: number;
		CardIssuer: number;
		FuelStationChange: number;
		Curator: number;
		Administrator: number;
		CommercialDirector: number;
		Contractor: number;
		HideServiceWallets: number;
	} | null;
	Version: number;
	EmptyFinancialPhones?: number;
}

export const loginResponseAdapter = (data: IEloginResponseAdapter): LoginResponse => {
	let userInfo = null;

	if (data.Roles) {
		userInfo = {
			roles: {
				expediter: data.Roles.Expediter,
				storeKeeper: data.Roles.StoreKeeper,
				cardIssuer: data.Roles.CardIssuer,
				fuelStationChange: data.Roles.FuelStationChange,
				curator: data.Roles.Curator,
				administrator: data.Roles.Administrator,
				commercialDirector: data.Roles.CommercialDirector,
				contractor: data.Roles.Contractor,
				hideServiceWallets: data.Roles.HideServiceWallets,
			},
		};
	}

	const result: LoginResponse = {
		token: data.SessionID,
		needSecondStep: data.NeedSecondStep === 1,
		user: userInfo,
		isAuth: data.NeedSecondStep === 0,
		emptyFinancialPhones: data.EmptyFinancialPhones ?? 0,
		OilWalletsUserId: data.OilWalletsUserId,
	};

	return result;
};
